
import React from 'react';
import { Badge } from '@/components/ui/badge';
import { useTranslation } from 'react-i18next';

export const BetaBadge = () => {
  const { t } = useTranslation();
  
  return (
    <Badge 
      className="bg-primary/20 text-primary hover:bg-primary/30 transition-colors ml-2"
      variant="secondary"
    >
      {t('beta')}
    </Badge>
  );
};
